export const group =
  <T, K extends string>(by: (item: T) => K) =>
  (array: T[]): Map<K, T[]> =>
    array.reduce((groups, item) => {
      const key = by(item)
      const group = groups.get(key) ?? []
      return groups.set(key, [...group, item])
    }, new Map<K, T[]>())
